enum ReviewPlatformNames {
  appStore = 'App Store',
  capterra = 'Capterra',
  g2 = 'G2',
  playStore = 'Play Store',
  trustpilot = 'Trustpilot',
  trustradius = 'Trustradius',
  productHunt = 'Product Hunt',
  salesforce = 'Salesforce',
  wordpress = 'Wordpress',
  shopify = 'Shopify',
}

enum ReviewPlatformLabels {
  appStore = 'App Store',
  capterra = 'Capterra',
  g2 = 'G2',
  playStore = 'Play Store',
  trustpilot = 'Trustpilot',
  trustradius = 'Trustradius',
  productHunt = 'Product Hunt',
  salesforce = 'Salesforce AppExchange',
  wordpress = 'WordPress',
  shopify = 'Shopify',
}

enum SyncIntegrationNames {
  freshdesk = 'freshdesk',
  gong = 'gong',
  helpscout = 'helpscout',
  intercom = 'intercom',
  zendesk = 'zendesk',
  api = 'api',
  zapier = 'zapier',
  // review platforms
  trustpilotReviews = 'trustpilot-reviews',
  appStoreReviews = 'appstore-reviews',
  playStoreReviews = 'playstore-reviews',
  g2Reviews = 'g2-reviews',
  capterraReviews = 'capterra-reviews',
  trustradiusReviews = 'trustradius-reviews',
  productHuntReviews = 'producthunt-reviews',
  salesforceReviews = 'salesforce-reviews',
  wordpressReviews = 'wordpress-reviews',
  shopifyReviews = 'shopify-reviews',
}

enum SyncReviewIntegrationNames {
  trustpilotReviews = SyncIntegrationNames.trustpilotReviews,
  appStoreReviews = SyncIntegrationNames.appStoreReviews,
  playStoreReviews = SyncIntegrationNames.playStoreReviews,
  g2Reviews = SyncIntegrationNames.g2Reviews,
  capterraReviews = SyncIntegrationNames.capterraReviews,
  trustradiusReviews = SyncIntegrationNames.trustradiusReviews,
  productHuntReviews = SyncIntegrationNames.productHuntReviews,
  salesforceReviews = SyncIntegrationNames.salesforceReviews,
  wordpressReviews = SyncIntegrationNames.wordpressReviews,
  shopifyReviews = SyncIntegrationNames.shopifyReviews,
}

export {
  ReviewPlatformNames,
  ReviewPlatformLabels,
  SyncIntegrationNames,
  SyncReviewIntegrationNames,
};
